import React, { useMemo } from 'react';
import { TypedMemo } from '../../../common/types';
import { SMLRouteNames } from '../../../../routing/sml/SMLRoutes';
import { SMLSectionTabs } from '../../components/SMLSectionTabs/SMLSectionTabs';
import { useFailedPostsCount } from '../../navigation/hooks/useFailedPostsCount';
import { postsMessages } from './postsMessages';
import { postsTabs } from './postsTabs';

interface PostsTabRowProps {
  accountId: number;
  /** The tab on screen. */
  screen: SMLRouteNames.promotePosts | SMLRouteNames.promoteCalendar;
}

/** The Board · Calendar row under the Posts title (design navigation-v2 c 3b, 3c). */
const PostsTabRowComponent: React.FC<PostsTabRowProps> = ({ accountId, screen }) => {
  // The same read as the menu badge: RTK Query shares the cache entry.
  const failedCount = useFailedPostsCount(accountId);
  const tabs = useMemo(() => postsTabs(screen, failedCount), [screen, failedCount]);
  return <SMLSectionTabs tabs={tabs} ariaLabel={postsMessages.title} />;
};

export const PostsTabRow = TypedMemo(PostsTabRowComponent);
